<template>
    <div>
        <!--导航条-->
        <div class="yg_nav">
<!--            <div class="yg-l">
                <div class="qiehu">
                    <ul>
                        <li class="sy"><a href="javascript:void(0)" @click="jump('hdshouye')">首页</a></li>
                        <li class="hd"><a href="javascript:void(0)" @click="jump('hdshezhi')">活动设置</a></li>
                    </ul>
                </div>
            </div>
 -->
        </div>

        <div style="width: 100%;height:2px;border-bottom:1px solid #dbdbdb; "></div> <!--下边线-->

        <!--导航条-->
        <!--导航条-->
        <div class="zhuti">
            <div class="huod_t">往期活动</div>
            <div style="clear: both"></div>
            <div class="tioamu" style="position: relative" v-for="(item,index) in huodongdata">
                <!--查看测评报告按钮-->
                <div class="btn btn-info btn-sm" v-if="item.tai == 2" style="position: absolute;right:100px;bottom: 10px ">查看测评报告</div>

                <!--查看测评报告按钮-->
                <div class="tiaomu_l">
                    <p class="xuhao">{{index+1}}</p>
                </div>
                <div class="tiaomu_r">
                    <div class="hang1">
                        <span>日期：{{item.start_time}}</span>
                        <span>活动类型：</span>
                        <span v-if="item.system_flag == 'M'">托育活动</span>
                        <span v-if="item.system_flag == 'G'">早教活动</span>
                        <span>负责人: <span v-for="(itema,index2) in item.teach">{{itema.username}},</span></span>
                        <span>预约：{{item.yuy}}人</span>
                        <span>实到：{{item.qian}}人</span>
                        <span>消耗课时:{{item.keshi}}节</span>
                        <!--<span>金额：{{item.money}}</span>-->
                        <span class="yjs"><img style="width: 50px;height: 24px" src="/static/qmsj/img/huodongq/12.png" alt=""></span>
                    </div>
                    <div class="hang1">
                        <span>活动名称：{{item.title}}</span>

                    </div>
                    <div class="hang1">
                        <span>活动介绍：{{item.jieshao}}</span>
                    </div>
                </div>
            </div>


            <span id="numm">共有{{count}}条记录&nbsp;&nbsp;当前{{nowpage}}页/共{{pagetotal}}页</span>
            <ul class="hylb-fenye" id="hui-fenye">
                <li><a href="javascript:void(0)" @click="getpage('first')">首页</a></li>
                <li><a href="javascript:void(0)" @click="getpage('prev')">上一页</a></li>
                <li><a href="javascript:void(0)" @click="getpage('next')">下一页</a></li>
                <li><a href="javascript:void(0)" @click="getpage('end')">尾页</a></li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                token: '',
                huodongdata:[],
                count:0,
                nowpage:1,
                pagetotal:1
            }
        },
        methods: {
            jump: function (e) {
                this.$router.push(e)
            },
            getpage:function(type){
                let self = this;
                var page = self.nowpage;
                if(type == 'first'){
                    page = 1;
                }else if(type == 'prev'){
                    page = parseInt(page) - 1;
                }else if(type == 'next'){
                    page = parseInt(page) + 1;
                }else if(type == 'end'){
                    page = self.pagetotal
                }
                if(page < 1){
                    page = 1;
                }
                if(page > self.pagetotal){
                    page = self.pagetotal
                }
                $.ajax({
                    url: process.env.apiUrl + "saas/activity/wqhd",
                    type: "post",
                    async: false,
                    data: {'token':self.token,'page':page},
                    success: function (data) {
                        self.huodongdata = data.data;
                        self.count = data.map.count;
                        self.nowpage = data.map.page;
                        self.pagetotal = data.map.pagetotal;
                    }
                })
            }
        },

        mounted: function () {
            var self = this
            self.token = self.$cookies.get("token")
            self.getpage('first');
        }
    }
</script>
<style scoped>
    *{margin: 0;padding: 0}
    a{text-decoration: none;}
    ul{list-style:none;margin: 0;padding: 0;}
    em,
    i{font-style: normal;font-weight: normal;}
    img {vertical-align: top;border: 0;margin:0;padding:0;width:100%;}
    h1, h2, h3, h4, h5, h6, .h1, .h2, .h3, .h4, .h5, .h6 {font-weight: 500;margin:0;padding:0;}
    *{margin: 0;padding:0;}
    input,a{outline:none;}
    .wrap {min-width: 320px; max-width: 640px; margin: 0 auto;}
    .fl{float:left;}
    .fr{float:right;}
    /*伪类清除浮动*/
    .fix{*zoom:1;}
    .fix:after{display:block; content:"clear"; height:0; clear:both; overflow:hidden; visibility:hidden;}
    body{
        width: 100%;
        background: #f6f6f6;
        font-family: "微软雅黑";
        font-size:14px;
    }

    /*导航部分*/

    .yg_nav{
        width: 93%;
        margin: 0 auto;
        height:60px;
    }

    .yg-l{width: 50%;
        float: left}
    .yg-r{width: 50%;
        float: left}
    .yg_nav1_1{
        display: block;
        float: left;
        width: 100%;
        font-size: 18px;
        height: 44px;
        line-height: 44px;

    }
    .qiehu{
        float: left;
        width: 245px;
        height: 43px;
        margin-top: 8px;
    }
    .sy{
        float: left;
        width:87px;
        height: 41px;
        line-height: 41px;
        text-align: center;
        background: #ececff;
        border-radius: 5px 5px 0 0;
        color:#8CBB77;
    }
    .sy>a{
        width: 100%;
        height: 100%;

        font-size: 16px;
        color: #000;
    }
    .hd{
        float: left;
        width:129px;
        height: 42px;
        background: #8CBB77;
        line-height:42px;
        margin-left: 15px;
        text-align: center;
        border-radius: 5px 5px 0 0;
    }
    .hylb-fenye{width: 316px;height: 20px;float: right;margin-right: -110px;}
    .hylb-fenye>li{float: left;width:43px;height: 20px;margin-left: 10px;border: 1px solid grey;
        font-size: 12px;
        text-align: center;
        cursor: pointer;
    }
    .hylb-fenye>li:nth-of-type(5){background:#8CBB77;color: white; }
    .hd>a{
        color: white;
        width: 100%;
        height: 100%;
        font-size: 16px;

    }
    .sousuo{
        float: right;
        width: 290px;
        height: 36px;
        margin-top: 50px;

    }
    label{
        margin: 0;
    }
    .suo{
        display: block;
        width: 100%;
        height: 100%;

    }
    .suoin{
        width: 238px;
        height: 33px;
        border: 1px solid #dbdbdb;
        border-radius: 5px;
    }
    .suosoutu{
        width: 35px;
        vertical-align: middle;
        padding-bottom: 2px;
    }
    .zhuti{
        width: 93%;
        margin: 26px auto 0;
    }
    /*
    .zhu_l{
        float: left;
        width: 100%;
        !*height: 560px;*!
      !*  border-right: 1px solid #dbdbdb;*!
    }
    */

    .huod_t{
        width: 100%;
        border-left:4px solid #8CBB77 ;
        height: 24px;
        line-height: 24px;
        padding-left: 6px;
        font-size: 16px;
        margin-bottom: 15px;
    }





    .tioamu{
        width: 100%;
        height: 126px;
        margin-bottom: 11px;
        background: #f3f4f8;
        box-shadow: 2px 0 0 0 #dbdbdb;
        border:  1px solid #dbdbdb;
    }
    .tiaomu_l{
        width: 4%;
        height: 124px;
        float: left;
        border-right: 1px solid #dbdbdb ;
    }
    .xuhao{
        width: 100%;
        height: 50px;
        line-height: 50px;
        font-style: italic;
        text-align: center;
        font-size: 18px;
        text-decoration:  underline;
    }
    .tiaomu_r{
        float: left;
        width: 96%;
    }
    .hang1{
        width: 100%;
        height: 41px;
        line-height: 41px;
    }
    .hang1>span{
        margin-left: 11px;
        margin-right: 55px;
    }
    .hang1>.yjs{
        margin-right: 18px;
        display: block;
        float: right;

    }
    .yjs>img{
        vertical-align: middle;
        /* margin-top: 3px;*/
    }
    .hang1{
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
    }
    .hang2{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
    }
    .hang3{
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
    }
</style>




// WEBPACK FOOTER //
// src/pages/huodong/wqhd.vue